import { render } from "./VideoComponent.vue?vue&type=template&id=5bd13140&ts=true"
import script from "./VideoComponent.vue?vue&type=script&lang=ts"
export * from "./VideoComponent.vue?vue&type=script&lang=ts"

import "./VideoComponent.vue?vue&type=style&index=0&id=5bd13140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__